import Vue from "vue";
import Router from "vue-router";
import home from "@/pages/home";
import information from "@/pages/information";
import encyclopedias from "@/pages/encyclopedias";
import classroom from "@/pages/classroom";
import expert from "@/pages/expert";
import hotline from "@/pages/hotline";
import smartPark from "@/pages/smartPark";
import handicraftsman from "@/pages/handicraftsman";
import teaCulture from "@/pages/teaCulture";

import register from "@/pages/register";
import login from "@/pages/login";

import seachlist from "@/pages/seachlist";

import questionDetails from "@/pages/questionDetails";
import expertDetail from "@/pages/expertDetail";
import classroomDetail from "@/pages/classroomDetail";
import questiontList from "@/pages/questiontList";
Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/home",
      name: "home",
      component: home,
      meta: {
        title: "农业技术管理平台",
        content: {
          keywords: "农业技术管理平台",
          description:
            "农业技术管理平台提供农技学习视频、农技专家咨询以及农技相关新闻资讯。"
        }
      }
    },
    {
      path: "/information",
      name: "information",
      component: information,
      meta: {
        title: "农业简讯 - 农业技术管理平台",
        content: {
          keywords: "农业简讯",
          description: "农业简讯包含农业相关新闻资讯，欢迎浏览。"
        }
      }
    },
    {
      path: "/encyclopedias",
      name: "encyclopedias",
      component: encyclopedias,
      meta: {
        title: "农业百科 - 农业技术管理平台",
        content: {
          keywords: "农业百科",
          description: "农业百科包含农业气象、行情、技术、病虫灾害等信息。"
        }
      }
    },
    {
      path: "/classroom",
      name: "classroom",
      component: classroom,
      meta: {
        title: "农业技术课堂 - 农业技术管理平台",
        content: {
          keywords: "农业技术课堂",
          description: "农技课堂包含各类安化农业技术课堂。"
        }
      }
    },
    {
      path: "/expert",
      name: "expert",
      component: expert,
      meta: {
        title: "农业专家 - 农业技术管理平台",
        content: {
          keywords: "农业专家",
          description: "农业专家栏目汇聚安化黑茶相关农业专家。"
        }
      }
    },
    {
      path: "/hotline",
      name: "hotline",
      component: hotline,
      meta: {
        title: "提交问答",
        isLogin: true
      }
    },
    {
      path: "/smartPark",
      name: "smartPark",
      component: smartPark
    },
    {
      path: "/handicraftsman",
      name: "handicraftsman",
      component: handicraftsman
    },
    {
      path: "/teaCulture",
      name: "teaCulture",
      component: teaCulture,
      meta: {
        title: "黑茶文化介绍 - 安化农技服务网",
        isLogin: true,
        content: {
          keywords: "黑茶文化介绍",
          description:
            "安化黑茶，湖南省益阳市安化县特产，中国国家地理标志产品。安化黑茶是六大基本茶类之一，属于后发酵茶，主要产品以茯砖、黑砖、花砖、青砖、湘尖等产品为主，在古代，一部分内销山西、陕西、甘肃、绥远、宁夏、新疆、西藏、蒙古等地，一部分加工制压成砖、除内销西北各地外，还外销苏俄，特称“砖茶”。安化黑茶是中国黑茶的始祖，在唐代（856年）的史料中记载。"
        }
      }
    },
    {
      path: "/register",
      name: "register",
      component: register,
      meta: { title: "注册" }
    },
    {
      path: "/login",
      name: "login",
      component: login,
      meta: { title: "登录" }
    },
    {
      path: "/seachlist",
      name: "seachlist",
      component: seachlist,
      meta: { title: "搜索列表" }
    },
    {
      path: "/questionDetails",
      name: "questionDetails",
      component: questionDetails,
      meta: { title: "热线问答详情" }
    },
    {
      path: "/wikidetails",
      name: "wikidetails",
      component: resolve => require(["../pages/WikiDetails.vue"], resolve),
      meta: { title: "百科详情" }
    },
    {
      path: "/searchDetails",
      name: "searchDetails",
      component: resolve => require(["../pages/searchDetails.vue"], resolve),
      meta: { title: "搜索详情" }
    },
    {
      path: "/informationDetail",
      name: "informationDetail",
      component: resolve =>
        require(["../pages/informationDetail.vue"], resolve),
      meta: { title: "资讯详情" }
    },
    {
      path: "/expertDetail",
      name: "expertDetail",
      component: expertDetail,
      meta: { title: "专家详情" }
    },
    {
      path: "/classroomDetail",
      name: "classroomDetail",
      component: classroomDetail,
      meta: { title: "课堂详情" }
    },
    {
      path: "/questiontList",
      name: "questiontList",
      component: questiontList,
      meta: {
        title: "农技相关热线问答 - 农业技术管理平台",
        isLogin: true,
        content: {
          keywords: "农技相关热线问答",
          description: "热线问答汇聚各类农业技术相关问题和答案。"
        }
      }
    }
  ]
});
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};



// WEBPACK FOOTER //
// ./src/router/index.js